import { Component } from '@angular/core';

@Component({
  selector: 'app-other-alerts',
  templateUrl: './other-alerts.component.html',
  styleUrls: ['./other-alerts.component.css']
})
export class OtherAlertsComponent {

}
